import { render, staticRenderFns } from "./adminAccount.vue?vue&type=template&id=8c7d5464"
import script from "./adminAccount.vue?vue&type=script&lang=js"
export * from "./adminAccount.vue?vue&type=script&lang=js"
import style0 from "./adminAccount.vue?vue&type=style&index=0&id=8c7d5464&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports